import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

document.querySelectorAll('.video-episodes').forEach((block) => {
    const grid = block.querySelector('.video-episodes__grid');

    if (grid) {
        new Swiper(grid, {
            modules: [Navigation, Pagination],

            slidesPerView: 1,
            spaceBetween: 42,
            pagination: {
                el: block.querySelector('.video-episodes__pagination'),
                clickable: true,
            },
            navigation: {
                prevEl: block.querySelector('.video-episodes__nav-prev'),
                nextEl: block.querySelector('.video-episodes__nav-next'),
            },

            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                },
                1025: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                },
            },
        });
    }

    const modal = block.querySelector('.video-episodes__modal');
    const video = block.querySelector('.video-episodes__modal-video');
    const closeButton = block.querySelector('.video-episodes__modal-close');
    const shareButton = block.querySelector('.video-episodes__modal-share');
    const toast = block.querySelector('.video-episodes__toast');
    const overlay = block.querySelector('.video-episodes__modal-overlay');

    if (!modal || !video) {
        return;
    }

    const episodeHashPrefix = '#episode-';
    const episodes = new Map();

    let currentEpisode = null;
    let toastTimer = null;

    const setHash = (hash) => {
        history.replaceState(null, '', hash || `${window.location.pathname}${window.location.search}`);
    };

    const showToast = (message) => {
        if (!toast) {
            return;
        }

        toast.textContent = message;
        toast.classList.add('is-visible');

        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(() => {
            toast.classList.remove('is-visible');
        }, 2500);
    };

    const copyText = async (text) => {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }

        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position: fixed; opacity: 0; pointer-events: none;';
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand('copy');
        field.remove();

        return copied;
    };

    function openModal(episode) {
        if (!episode || !episode.url) {
            return;
        }

        if (video.getAttribute('src') !== episode.url) {
            video.src = episode.url;
            video.load();
        } else {
            video.currentTime = 0;
        }

        currentEpisode = episode;
        modal.classList.add('is-open');
        document.body.classList.add('video-episodes-modal-open');
        setHash(`${episodeHashPrefix}${episode.id}`);

        video.play().catch(() => {
        });
    }

    function closeModal(clearHash = true) {
        video.pause();
        video.currentTime = 0;
        modal.classList.remove('is-open');
        document.body.classList.remove('video-episodes-modal-open');
        currentEpisode = null;

        if (clearHash) {
            setHash('');
        }
    }

    const openFromHash = () => {
        const id = window.location.hash.startsWith(episodeHashPrefix)
            ? window.location.hash.slice(episodeHashPrefix.length)
            : '';

        if (id && episodes.has(id)) {
            openModal(episodes.get(id));
        } else if (modal.classList.contains('is-open')) {
            closeModal(false);
        }
    };

    block.querySelectorAll('.video-episodes__watch').forEach((button) => {
        const episode = {
            id: button.dataset.episodeId,
            title: button.dataset.episodeTitle,
            url: button.dataset.videoUrl,
        };

        if (!episode.id || !episode.url) {
            return;
        }

        if (!episodes.has(episode.id)) {
            episodes.set(episode.id, episode);
        }

        button.addEventListener('click', () => {
            openModal(episode);
        });
    });

    closeButton?.addEventListener('click', closeModal);
    overlay?.addEventListener('click', closeModal);

    shareButton?.addEventListener('click', async () => {
        if (!currentEpisode) {
            return;
        }

        const url = `${window.location.origin}${window.location.pathname}${window.location.search}${episodeHashPrefix}${currentEpisode.id}`;
        const title = currentEpisode.title || document.title;

        if (navigator.share) {
            try {
                await navigator.share({title, url});
            } catch {
                // The native share sheet rejects with AbortError when dismissed.
            }

            return;
        }

        try {
            if (await copyText(url)) {
                showToast(shareButton.dataset.copiedLabel);
            } else {
                showToast(shareButton.dataset.errorLabel);
            }
        } catch {
            showToast(shareButton.dataset.errorLabel);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });

    window.addEventListener('hashchange', openFromHash);
    openFromHash();
});
